import { query, request } from '@/utils/request';

// 我的订单列表
export async function getOrderList(data) {
  return request('/zlb/api/expense/purchase/order/list', { method: 'POST', data });
}

// 关联申请单
export async function connectApplyForm(data) {
  return query('/zlb/api/expense/purchase/order/uniteApplyForm', { method: 'POST', data });
}

// 单位信息查询
export const reqCompanyInfo = async params => {
  return query('/zlb/api/expense/apply-form/default-info', {
    params,
  });
};

// 取消关联申请单
export const unConnectApplyForm = async data => {
  return query('/zlb/api/expense/purchase/order/undoApplyForm', {
    method: 'POST',
    data,
  });
};
